import { resizeContent } from '../blocks/text-box/inc/resize-content';
import { headingSideHorizontalBorder } from './inc/core-heading-side-horizontal-border';
import { setUpBlockAccordion } from './inc/block-accordion';
import { setUpPageHeader } from './inc/block-page-header';

addEventListener("DOMContentLoaded", (event) => {
	// new-standard/text-box の文字サイズ調整
	const textBoxBlocks = document.getElementsByClassName("wp-block-new-standard-text-box");

	const textBoxBlockEls = Array.from(textBoxBlocks);

	textBoxBlockEls.forEach(el => {
		const resizeObserver = new ResizeObserver((entries) => {
			resizeContent(entries[0].target);
		});

		resizeContent(el);
		resizeObserver.observe(el);
	});

	// core/heading の横ボーダー
	headingSideHorizontalBorder();
	window.onresize = headingSideHorizontalBorder;

	// new-standard/block-accordion の開閉
	setUpBlockAccordion();

	// new-standard/page-header の検索ボタン
	setUpPageHeader();
});
